/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Trennungsjahr_700px.jpg";
import Typography from "@mui/material/Typography";
import { Link as MuiLink, Paper } from "@mui/material";
import { gaSet } from "../../../services/googleAnalyticsService";
import { Link } from "react-router";

const GuidebookDivorceRequirements = () => {
  const title = "Ratgeber - Scheidungsvoraussetzungen | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Was sind die Voraussetzungen für eine Scheidung? Wir erklären Ihnen das sogenannte Trennungsjahr und
            unter welchen Bedingungen Sie sich scheiden lassen können."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan
          slogan={"Wann kann ich mich scheiden lassen?"}
          backgroundImagePath={backgroundTeaser}
          height={300}
          headingColor={"#333333"}
        />
        <TextContainer>
          <p>
            Was sind die Voraussetzungen für eine Scheidung? Wir erklären Ihnen das sogenannte Trennungsjahr und unter welchen Bedingungen Sie sich scheiden
            lassen können.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Die Grundvoraussetzung: das Trennungsjahr
          </Typography>
          <p>
            Die wichtigste Voraussetzung für eine Scheidung ist, dass die Ehepartner seit einem Jahr getrennt leben. Dieses Trennungsjahr ist gesetzlich
            vorgeschrieben, um sich offiziell scheiden lassen zu können. Im Trennungsjahr sollten die Ehepartner getrennt voneinander leben. Dies geschieht
            bestenfalls in getrennten Wohnungen, eine Trennung innerhalb des Wohnraums ist jedoch auch ausreichend, solange sich die Ehegatten kein Bett mehr
            teilen und getrennt voneinander wirtschaften. Wenn beide Ehepartner den Termin für die Trennung und somit das Scheitern der Ehe bestätigen, können
            Sie sich scheiden lassen. Der Scheidungsantrag kann in der Regel einige Wochen vor Ablauf des Trennungsjahres eingereicht werden, sofern keine
            Streitigkeiten oder Besonderheiten auftreten.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Anwaltspflicht und Scheidungsantrag
          </Typography>
          <p>
            Um sich scheiden lassen zu können, ist in Deutschland mindestens ein Anwalt notwendig. Dieser reicht den sogenannten Scheidungsantrag bei Gericht
            für Sie ein und ist auch beim Scheidungstermin vor Gericht anwesend. Beim Scheidungsantrag handelt es sich um ein detailliertes Schreiben, das alle
            Angaben zu Ihnen, dem Ehepartner, Ehe und Trennung, Finanzen und ggf. gemeinsamen Kindern enthält. Auf Grundlage des Scheidungsantrags kann das
            Gericht Ihre Scheidung durchführen und die{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/familienrecht/scheidungskosten"}>
              Kosten für die Scheidung{" "}
            </MuiLink>
            festsetzen. Wenn Sie sich scheiden lassen möchten, müssen Sie verschiedene Themen mit Ihrem Partner abklären und schriftlich festhalten. Mehr Infos
            zu den sogenannten Scheidungsfolgen finden Sie{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/familienrecht/wichtige-themen-ueberblick"}>
              hier
            </MuiLink>
            .
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Mit Ihrer Scheidung starten
          </Typography>
          <p>
            Sie sind von Ihrem Partner getrennt und möchten sich scheiden lassen? Dann können Sie in Ihrer Servicewelt jederzeit alle Angaben für den
            Scheidungsantrag machen und somit ganz einfach und sicher mit Ihrer Scheidung starten.
          </p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookDivorceRequirements;
